// Preloader functionality
(function() {
  'use strict';

  // Hide preloader with fade-out animation
  function hidePreloader() {
    const preloader = document.getElementById('preloader');
    if (preloader && !preloader.classList.contains('fade-out')) {
      // Start fade-out animation
      preloader.classList.add('fade-out');
      
      // Remove from DOM after animation completes
      setTimeout(() => {
        preloader.classList.add('hidden');
        document.body.classList.add('loaded');
      }, 500); // Match the CSS transition duration
    }
  }

  // Initialize preloader
  function initPreloader() {
    // Hide preloader when page is fully loaded
    if (document.readyState === 'complete') {
      hidePreloader();
    } else {
      window.addEventListener('load', hidePreloader);
    }

    // Force hide preloader after maximum timeout (3 seconds)
    setTimeout(() => {
      hidePreloader();
    }, 3000);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPreloader);
  } else {
    initPreloader();
  }

})();